import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrCrIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M10.28 1.84H9.52C9.26 1.3 8.71 0.92 8.06 0.92H7.91C7.65 0.38 7.1 0 6.45 0H5.53C4.89 0 4.33 0.38 4.07 0.92H3.92C3.28 0.92 2.72 1.3 2.46 1.84H1.71C0.76 1.84 0 2.61 0 3.55V14.28C0 15.23 0.77 15.99 1.71 15.99H10.29C11.24 15.99 12 15.22 12 14.28V3.55C12 2.6 11.23 1.84 10.29 1.84H10.28ZM3.92 2.33H8.06C8.18 2.33 8.28 2.43 8.28 2.55C8.28 2.67 8.18 2.77 8.06 2.77H3.92C3.8 2.77 3.7 2.67 3.7 2.55C3.7 2.43 3.8 2.33 3.92 2.33ZM10.58 14.29C10.58 14.46 10.44 14.59 10.28 14.59H1.7C1.53 14.59 1.4 14.45 1.4 14.29V3.55C1.4 3.38 1.54 3.25 1.7 3.25H2.45C2.71 3.79 3.26 4.17 3.91 4.17H8.05C8.69 4.17 9.25 3.79 9.51 3.25H10.27C10.44 3.25 10.57 3.39 10.57 3.55V14.28L10.58 14.29ZM9.23 6.71C9.23 7.11 8.93 7.42 8.52 7.42H3.7C3.3 7.42 2.99 7.12 2.99 6.71C2.99 6.3 3.29 6 3.7 6H8.53C8.93 6 9.24 6.3 9.24 6.71H9.23ZM7.23 12.33C7.23 11.93 6.92 11.63 6.52 11.63H3.69C3.28 11.63 2.98 11.92 2.98 12.33C2.98 12.74 3.29 13.04 3.69 13.04H6.52C6.93 13.04 7.23 12.73 7.23 12.33ZM9.23 9.52C9.23 9.92 8.93 10.23 8.52 10.23H3.7C3.3 10.23 2.99 9.93 2.99 9.52C2.99 9.11 3.29 8.81 3.7 8.81H8.53C8.93 8.81 9.24 9.11 9.24 9.52H9.23Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrCrIconComponent;
